module.exports = __webpack_public_path__ + "img/gargoyle_zorn.4d4fd25a.png";